// extracted by mini-css-extract-plugin
module.exports = {"searchFormContainer":"SearchFormWrapper_searchFormContainer__1nRRa","emptyInput":"SearchFormWrapper_emptyInput__wj8vd","fullInput":"SearchFormWrapper_fullInput__11sE-"};